import React, { useEffect, useState, useRef } from "react";
import PrintDropdowns from './print-drop-downs';

import PrintCheckBoxes from "./print-checkboxes";
//@ts-ignore
import Cookie from 'js-cookie';
import {
  CookieKeys,
} from '../react-flow-pedigree/pedigree-constants';

import { getDocument } from "pdfjs-dist/legacy/build/pdf.mjs";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs';
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

interface PrintSettingsProps {
    svgForPrint: any;
    blobType?: string;
    deIdentify: boolean;
    blackAndWhite: boolean;
    readOnlyUser: boolean;
    initialSettings: PrintSettings;
    has_deidentified_role: boolean;

    printPedigree: (print: any) => void;
    updateSvgForPrint: (option: PrintSettings) => void;
    closeModal: () => void;

  }

interface PrintSettings{
  orientation: string;
  pages: string;
  options: string;
  deidentified: boolean;
  blackWhite: boolean;
}

const printOrientation = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' }
];

const printOptions = [
  { label: 'PDF', value: 'pdf' },
  { label: 'PNG', value: 'image' }
]

const printPages = [
  { label: 'Single', value: 'FitToPage' },
  { label: 'Multiple', value: 'FitToOnePageTall' }
];

const ModalPrintSettings: React.FC<PrintSettingsProps> = ({closeModal, printPedigree, updateSvgForPrint, svgForPrint, blobType, initialSettings,readOnlyUser, has_deidentified_role}) =>{
  const containerRef = useRef<HTMLDivElement>(null);
  const [disabledOptions, setDisabledOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(1);
  const [printSettings, setPrintSettings] = useState<PrintSettings>(initialSettings);
  const [modalHeight, setModalHeight] = useState(() => {
    if (typeof window !== 'undefined') {
      const screenHeight = window.innerHeight;
      console.log('Screen Height:', screenHeight);
      if (screenHeight < 600) return 440;
      if (screenHeight < 800) return 520;
      return 700;
    }
    return 450;
  });

  useEffect(() => {
    setLoading(false);
    const renderPDF = async () => {
      try {
        if (!svgForPrint) {
          return;
        }

        const container = containerRef.current;
        if (!container) {
          return;
        }

        container.innerHTML = '';
        if (blobType === 'pdf') {
          const loadingTask = getDocument(svgForPrint);
          const pdf = await loadingTask.promise;
          const numPages = pdf.numPages ?? 1;

          const page = await pdf.getPage(currentPage);
          const scale = window.innerWidth / page.getViewport({ scale: 2.5 }).width;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.display = 'block';
          canvas.style.border = '2px solid #cccccc';
          container.appendChild(canvas);

          const context = canvas.getContext('2d');
          if (!context) {
            throw new Error(`Canvas context is null for page: ${currentPage}`);
          }

          const renderContext = {
            canvasContext: context,
            viewport: viewport,
            canvas: canvas,
          };

          await page.render(renderContext).promise;
          setNumPages(numPages);
        } else if (blobType === 'image') {
          const img = document.createElement('img');
          img.src = svgForPrint;
          img.alt = 'Rendered image';
          img.style.maxWidth = '100%';
          img.style.display = 'block';
          img.style.border = '2px solid #cccccc';
          container.appendChild(img);
        } else {
          throw new Error(`Unsupported file type: ${blobType}`);
        }

        setLoading(false); 
      } catch (err: any) {
        console.error('Error rendering PDF/Image:', err);
        setLoading(false); 
        throw new Error(`Error rendering: ${err.message}`);
      }
    };

    renderPDF();

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [svgForPrint, currentPage, blobType]);


  const updatePrintSetting = (key: string, value: string | boolean) => {
    setLoading(true);
    setPrintSettings(prevSettings => {
      const newSettings = { ...prevSettings, [key]: value };
      updateSvgForPrint(newSettings);
      return newSettings;
    });
  }

  const updateOrientation = (orientation: any) => {
    let value = orientation.value || 'portrait';
    updatePrintSetting('orientation', value)

  }

  const updateFormat = (options: {Label: string, value: string}) => {
    if(options.value === 'image') setDisabledOptions(true)
    else setDisabledOptions(false)
    updatePrintSetting('options', options.value)
  }

  const updatePages = (pages: any) => {

    let value = pages.value || 'FitToPage';
    if(value ==='FitToPage' && numPages > 1){
      setCurrentPage(1);
      setNumPages(1);
    }

    updatePrintSetting('pages', pages.value)
  }


  const closePrintModal = () => {
    Cookie.set(CookieKeys.PEDIGREE_PRINT_SETTINGS, JSON.stringify(printSettings));
    closeModal();
  }

  function print() {
    printPedigree(svgForPrint);
  }

  const goToPreviousPage = () => {
    if (currentPage <= 1) return;
    setCurrentPage(currentPage - 1);
  }
  const goToNextPage = () => {
    if (currentPage >= numPages) return;
    setCurrentPage(currentPage + 1);
  }

  const format = printOptions.find(item => printSettings.options === item.value)
  const orientation = printOrientation.find(item => printSettings.orientation === item.value)
  const pages = printPages.find(item => printSettings.pages === item.value)

  return (
    <div
      className="modal fade in"
      role="dialog"
      style={{ zIndex: 9999, display: "block", paddingTop: '25px', backgroundColor: 'transparent'}}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="modal-dialog modal-lg"
        style={{ 
          width: window.innerWidth < 768 ? '95%' : window.innerWidth < 1024 ? '75%' : '50%'
        }}
        role="document"
      >
        <div className="modal-content">
            <div className="modal-header">
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={closeModal}
                >
                    <i onClick={closeModal}className="fa fa-close" />
                </button>
                <h4 className="modal-title text-capitalize">
                    Save As PDF / Image
                </h4>
            </div>

          <div id='family-history-modal' style={{ height: `${modalHeight-55}px`,  paddingTop: '5px' }} className="modal-body pedigree-print-settings">

            <div className="print-options">
                <div className="form-group">
                    <PrintDropdowns
                      label="Format"
                      options={printOptions}
                      selectedValue={format}
                      onSelect={updateFormat}
                    />
                  </div>
                <div className="form-group">
                    <PrintDropdowns
                      label="Orientation"
                      options={printOrientation}
                      selectedValue={orientation}
                      onSelect={updateOrientation}
                      disabled={disabledOptions}
                    />
                  </div>
                  <div className="form-group">
                    <PrintDropdowns
                      label="Pages"
                      options={printPages}
                      selectedValue={pages}
                      onSelect={updatePages}
                      disabled={disabledOptions}

                    />
                  </div>

                  <div className="form-group">
                    <PrintCheckBoxes
                      has_deidentified_role={has_deidentified_role}
                      updateBlackWhite={(blackWhite: boolean) =>
                        updatePrintSetting('blackWhite', blackWhite)
                      }
                      updateDeIdentify={(identify: boolean) =>
                        updatePrintSetting('deidentified', identify)
                      }
                      deidentified={printSettings.deidentified ? printSettings.deidentified : false}
                      blackWhite={printSettings.blackWhite ? printSettings.blackWhite : false}
                    />
                  </div>
                </div>
            <div style={{ width: '100%' }}>
              <div
                ref={containerRef}
                
                style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                margin: 0,
                padding: 0,
                overflow: 'hidden',
                opacity: loading ? 0.3 : 1,
                transition: 'opacity 0.2s ease-in-out',
                }}
              />
              {numPages > 1 && (
                <div
                style={{
                  marginTop: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 16,
                  width: '100%',
                }}
                >
                <i
                  className="fa fa-chevron-left"
                  aria-label="Previous page"
                  onClick={() => currentPage > 1 && goToPreviousPage()}
                  style={{
                  cursor: currentPage > 1 ? 'pointer' : 'not-allowed',
                  opacity: currentPage > 1 ? 1 : 0.3,
                  fontSize: 18,
                  }}
                />
                <span style={{ fontSize: 12 }}>
                  Page {currentPage} of {numPages}
                </span>
                <i
                  className="fa fa-chevron-right"
                  aria-label="Next page"
                  onClick={() => currentPage < numPages && goToNextPage()}
                  style={{
                  cursor: currentPage < numPages ? 'pointer' : 'not-allowed',
                  opacity: currentPage < numPages ? 1 : 0.3,
                  fontSize: 18,
                  }}
                />
                </div>
              )}
            </div>
          </div> 

        <div className="modal-footer" style={{padding:'10px'}}>
          <div style={{textAlign: 'right'}}>
                <button
                    type="button"
                    onClick={closePrintModal}
                    className="btn btn-light-outline "
                    style={{ marginRight: 5 }}
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-dark "
                    data-toggle="modal"
                    data-dismiss="modal"
                    style={{ marginRight: 5}}
                    onClick={print}
                  >
                  Continue
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default ModalPrintSettings;
